(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('ProjectStatus', ProjectStatus);

    ProjectStatus.$inject = ['$resource'];

    /* @ngInject */
    function ProjectStatus($resource) {
        return $resource('api/order/getstatus', null,
            {
                'get': { method:'GET', cache: true}
            });
    }

})();

